<template>
  <label
    class="product-sale"
    :id="'attrPrice_' + saleMetode.attrPriceId"
    :attr_price_title_id="saleMetode.attrPriceId"
    :attr_price_val_id="saleMetode.valuePriceId"
    :for="'attrPriceTitle_' + saleMetode.valuePriceId"
  >
    <div class="metode_div">
      <div class="check_mark">
        <input
          type="radio"
          :id="'attrPriceTitle_' + saleMetode.valuePriceId"
          :name="'attrPriceItem_' + saleMetode.attrPriceId"
          value="HTML"
        />
      </div>
      <p class="product-sale-metode">
        {{ saleMetode.metode }}
      </p>
    </div>
    <p
      v-if="saleMetode?.price && saleMetode.price > 0"
      class="product-sale-price"
    >
      {{ saleMetode.price + "+" }}
    </p>
    <p v-else class="product-sale-unset">...</p>
  </label>
</template>

<script>
import { addCommas, digitsEnToFa } from "persian-tools2";
export default {
  name: "ProductSale",
  props: { saleMetode: Object },
  methods: {},
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/components/ProductSale/ProductSale.css);
</style>